import React, { useEffect, useRef } from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';
import 'chartjs-adapter-date-fns';
import { Line } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

export const options = {
  responsive: true,
  plugins: {
    legend: {
      position: 'top',
    },
    title: {
      display: false,
      text: 'Flow',
    }
  },
  elements: {
    point: {
      radius: 5,
    },
  },
  layout: {
    padding: {
      left: 20,
      right: 20,
    }
  },
  interaction: {
    mode: 'index',
    intersect: false,
    callbacks: {
      title: tooltipItems => {
        let label = 'Flow';
        return label;
      },
      label: (item, data) => {
        return `PSI: ${item.formattedValue}, GPM: ${item.label}`;
      }
    },
  },
  scales: {
    x: {
      type: 'category',
      display: true,
      position: 'bottom',
      title: {
        display: true,
        align: 'center',
        text: 'GPM'
      },
    },
    y: {
      type: 'linear',
      display: true,
      position: 'left',
      title: {
        display: true,
        align: 'center',
        text: 'PSI'
      },
    }
  },
};

const PSIGPMChart = ({ psiGPMs }) => {
  const chartRef = useRef(null);

  useEffect(() => {
    window.addEventListener('beforeprint', resizeChartsBeforePrint);
    window.addEventListener('afterprint', resizeChartAfterPrint);
    return () => {
      window.removeEventListener('beforeprint', resizeChartsBeforePrint);
      window.removeEventListener('afterprint', resizeChartAfterPrint);
      chartRef.current?.destroy();
    }
  }, []);

  const resizeChartsBeforePrint = () => {
    chartRef.current?.resize(Infinity, 300);
  };
  const resizeChartAfterPrint = () => {
    chartRef.current?.resize();
  }

  const data = {
    labels: psiGPMs?.sort((a, b) => a.gpm - b.gpm).map(t => t.gpm.toFixed(2)) ?? [],
    datasets: [
      {
        label: 'Flow',
        data: psiGPMs?.map(t => { return { x: t.gpm, y: t.psi }}) ?? [],
        borderColor: '#999999',
        // backgroundColor: 'rgba(2, 165, 255, 0.5)',
        pointBorderColor: function(context) {
          var index = context.dataIndex;
          var value = context.dataset.data[index].y;
          return value <= 20 ? 'rgba(255, 0, 0, 1)' : '#02a5ff';
        },
        pointBackgroundColor: function(context) {
          var index = context.dataIndex;
          var value = context.dataset.data[index].y;
          return value <= 20 ? 'rgba(255, 0, 0, 0.5)' : 'rgba(2, 165, 255, 0.5)';
        },
        borderWidth: 1,
        yAxisID: 'y',
        xAxisID: 'x',
      }
    ],
  };

  return (
    <div className="chart print-h-300" style={{ width: "100%", display: "flex", justifyContent: "center", flexDirection: "row" }}>
      <Line ref={chartRef} options={options} data={data} plugins={[{ id: 'colorChanger' }]} />
    </div>
  );
};

export default PSIGPMChart;